// ==== assets/customproductbuilder-inline-qty.js  (create a new asset if you want) ====
document.addEventListener('DOMContentLoaded', function () {
    console.log('CPB inline quantity script loaded');

    window.inlineCounters = window.inlineCounters || {};   // ← CORRECT — global!

    // Wait for CPB to be fully loaded
function waitForCPB() {
    if (window.CPB?.builder?.getStore) {
        console.log('CPB store ready');
        return Promise.resolve();
    }
    return new Promise(resolve => {
        const check = setInterval(() => {
            if (window.CPB?.builder?.getStore) {
                clearInterval(check);
                console.log('CPB store ready (delayed)');
                resolve();
            }
        }, 100);
    });
}

    const inlineCounters = window.inlineCounters;         // ← now we use the global one

    // Main function that injects inline quantity next to every checkbox
    function injectInlineQuantities() {
        console.log('Running injectInlineQuantities...');

        let injected = 0;
        document.querySelectorAll('.cpb-checkbox-group').forEach(group => {
            const $group = $(group); // we can use jQuery here
            const optionId = group.getAttribute('data-option-id');
            if (!optionId || group.querySelector('.my-inline-qty')) return;

            // Create inline quantity
            const inlineHTML = `
                <div class="my-inline-qty" style="display:none; margin-left:16px; align-items:center; gap:8px;">
                    <button type="button" class="my-qty-btn my-qty-minus" style="width:32px;height:32px;">−</button>
                    <input type="number" class="my-qty-input" value="0" min="0" style="width:60px; text-align:center; height:32px;">
                    <button type="button" class="my-qty-btn my-qty-plus" style="width:32px;height:32px;">+</button>
                </div>
            `;

            // Insert after the label
            const label = group.querySelector('label');
            if (label) {
                label.insertAdjacentHTML('afterend', inlineHTML);
                const inlineWrapper = label.nextElementSibling;

                // Store reference
                inlineCounters[optionId] = inlineWrapper;

                // Event handlers
                inlineWrapper.querySelector('.my-qty-minus').addEventListener('click', () => changeQty(optionId, -1));
                inlineWrapper.querySelector('.my-qty-plus').addEventListener('click', () => changeQty(optionId, +1));
                inlineWrapper.querySelector('.my-qty-input').addEventListener('input', function () {
                    let val = parseInt(this.value) || 0;
                    if (val < 0) val = 0;
                    this.value = val;
                    changeQty(optionId, val, true);
                });

                injected++;
            }
        });

        console.log(`Injected ${injected} inline quantities`);
        if (injected > 0) observeCheckboxes(); // only once
    }

    // When checkbox is clicked → show/hide inline qty + set 1 or 0
    function observeCheckboxes() {
        document.querySelectorAll('.cpb-checkbox-input').forEach(checkbox => {
            checkbox.addEventListener('change', function () {
                const optionId = this.closest('[data-option-id]')?.getAttribute('data-option-id');
                if (!optionId || !inlineCounters[optionId]) return;

                const inline = inlineCounters[optionId];
                if (this.checked) {
                    inline.style.display = 'flex';
                    inline.querySelector('.my-qty-input').value = 1;
                    syncToCpb(optionId, 1);
                } else {
                    inline.style.display = 'none';
                    inline.querySelector('.my-qty-input').value = 0;
                    syncToCpb(optionId, 0);
                }
            });
        });
    }

    // This is the magic: change CPB's real hidden input
    // ──────────────────────────────────────────────────────────────
// THIS IS THE ONLY FUNCTION YOU NEED TO CHANGE
// ──────────────────────────────────────────────────────────────
function syncToCpb(optionId, qty) {
    // This is the REAL way to change quantity in CPB
    if (!window.CPB || !CPB.builder || !CPB.builder.getStore) {
        console.warn('CPB store not ready yet');
        return;
    }

    const store = CPB.builder.getStore();
    const state = store.getState();

    // Find the option in CPB's internal state
    const optionKey = Object.keys(state.options || {}).find(key => 
        state.options[key]?.optionId === optionId || key.includes(optionId)
    );

    if (!optionKey) {
        console.warn('Option not found in CPB store:', optionId);
        return;
    }

    // THIS IS THE ONLY LINE THAT ACTUALLY CHANGES QUANTITY
    store.dispatch({
        type: 'OPTION_VALUE_CHANGE',
        payload: {
            optionKey: optionKey,
            value: qty
        }
    });

    console.log(`CPB quantity updated: ${optionId} → ${qty}`);
}

    // Our +/- buttons
    function changeQty(optionId, delta, absolute = false) {
        const inline = inlineCounters[optionId];
        if (!inline) return;

        let current = parseInt(inline.querySelector('.my-qty-input').value) || 0;
        let newQty = absolute ? delta : current + delta;
        if (newQty < 0) newQty = 0;

        inline.querySelector('.my-qty-input').value = newQty;
        syncToCpb(optionId, newQty);

        // Auto-check the checkbox if qty > 0
        const cb = document.querySelector(`[data-option-id="${optionId}"] .cpb-checkbox-input`);
        if (newQty > 0 && cb && !cb.checked) {
            cb.checked = true;
            cb.dispatchEvent(new Event('change'));
        }
    }

    // Run when CPB tells us it updated
    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
        console.log('CPB mounted → injecting inline qty');
        setTimeout(injectInlineQuantities, 500);
    });
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', () => {
        setTimeout(injectInlineQuantities, 300);
    });
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
        setTimeout(injectInlineQuantities, 300);
    });

    // Fallback: try every 2 seconds (just in case)
    const interval = setInterval(() => {
        if (document.querySelector('.cpb-checkbox-group')) {
            injectInlineQuantities();
            // clearInterval(interval); // uncomment when you're sure
        }
    }, 2000);

    // Initial try
    setTimeout(injectInlineQuantities, 1000);
});